/**
 * Shared dice asset types used by:
 * - dice-editor (authoring skins)
 * - client (loading + rendering skins in game)
 * - main-server (storing + serving dice data)
 */
// ── Default Die ─────────────────────────────────────────────────
/**
 * The starter red die every account is granted at signup (main-server
 * config.game.defaultDice serves it; this constant is the single source).
 * The client uses it as the visual stand-in for any equipped slot that is
 * empty or whose skin hasn't loaded — a real die with a correct face map,
 * instead of the procedural pip box whose face layout can contradict the
 * authoritative roll result.
 */
export const DEFAULT_DICE_ID = 'dss01-d52c4bac';
// ── Dice Document ───────────────────────────────────────────────
export const TIER_OPTIONS = [
    'Common',
    'Uncommon',
    'Rare',
    'Epic',
    'Legendary',
    'Mythic',
    'Exotic',
];
// ── Environment Presets (shared editor + client) ────────────────
/**
 * Cubemap env presets and their image file extension. Single source of truth
 * so the editor (authoring) and client (gameplay) load identical assets.
 * Editor serves them from `${BASE_URL}env/<preset>/`; client from
 * `${BASE_URL}assets/env/<preset>/`.
 */
export const ENV_PRESET_EXT = {
    grass: 'png', moon: 'png', night: 'png', quarry: 'png', quarry2: 'png', quarry3: 'png',
    red: 'png', road: 'png', royal: 'jpg', royal2: 'jpg', studio: 'png', tanto: 'jpg',
    tarmac: 'png', tarmac2: 'png',
};
/** Preset names, in display order. */
export const ENV_PRESET_NAMES = Object.keys(ENV_PRESET_EXT);
/** Cubemap face order expected by THREE.CubeTextureLoader. */
export const ENV_CUBE_FACES = ['px', 'nx', 'py', 'ny', 'pz', 'nz'];
//# sourceMappingURL=DiceAssetTypes.js.map